import { render, staticRenderFns } from "./BillIcon4.vue?vue&type=template&id=441e22e6&"
import script from "./BillIcon4.vue?vue&type=script&lang=ts&"
export * from "./BillIcon4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports